import React from 'react';
import styled from '@emotion/styled';
import { rgba } from 'polished';
import icon from '@devsisters/ui-common/lib/icon';
import { useTexts, useLocale } from '@devsisters/gatsby-plugin-i18n';
import $ from 'text2vdom';

import { asset } from '~/src/assets';
import { scaledCss } from '~/src/css';

interface FooterProps {
  className?: string;
  style?: React.CSSProperties;
}
const Footer: React.FC<FooterProps> = ({ className, style }) => {
  const t = useTexts();
  const locale = useLocale();
  return (
    <FooterContainer className={className} style={style}>
      <LogoImg src={asset(`bravecookies/logo/${locale}.png`)} />
      <InfoBox>
        <InfoIconInInfoBox />
        <div>{$(t`$precautions`)}</div>
      </InfoBox>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled('footer')(
  scaledCss({
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    padding: [25, '25px'],
    backgroundColor: '#171a1e',
  })
);

const LogoImg = styled('img')(
  scaledCss({
    marginRight: [20, '20px'],
    width: [100, '100px'],
  })
);

const InfoBox = styled('div')(
  scaledCss({
    flexGrow: 1,
    display: 'flex',
    alignItems: 'flex-start',
    paddingX: [14, '14px'],
    paddingY: [10, '10px'],
    lineHeight: 1.4,
    fontSize: [18, '18px'],
    fontFamily: "'Noto Sans', sans-serif",
    color: '#f1f7ff',
    backgroundColor: rgba('#c7ebff', 0.2),
    borderRadius: [20, '20px'],
    '&:lang(ko)': {
      fontFamily: "'Noto Sans KR', sans-serif",
    },
    '&:lang(zh-Hant)': {
      fontFamily: "'Noto Sans TC', sans-serif",
    },
  })
);

const InfoIcon = icon(
  '0 0 20 20',
  <path d="M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10c5.5,0,10-4.5,10-10S15.5,0,10,0z M11.2,15.5H8.8v-1.8h2.5V15.5z M11,12.2H9L8.7,4.1h2.7L11,12.2z" />
);

const InfoIconInInfoBox = styled(InfoIcon)(
  scaledCss({
    marginTop: [4, '4px'],
    marginRight: '0.5em',
  })
);
